<template>
    <div class="function-panel">
        <div class="left">
            <div class="bjy-spacer"></div>

            <!-- 录制按钮 -->
            <Record class="bjy-custom-record" v-if="!isStudent" />

            <div v-if="!isStudent" @click="toggleQuiz">测验</div>

            <div v-if="!isStudent" @click="toggleAnswer">答题器</div>

            <div v-if="!isStudent" @click="toggleMediaPlayer">播放</div>

            <div v-if="!isStudent" @click="toggleRollCall">点名</div>

            <div v-if="!isStudent" @click="toggleLottery">抽奖</div>

            <div v-if="!isStudent" @click="toggleAttentionDetection">专注度检测</div>
            <div v-if="!isStudent" @click="toggleAnswerRacer">抢答器</div>
        </div>

        <div class="right">
            <template v-if="liveInfo && liveInfo.webrtc === 1">
                <!-- 举手菜单 默认显示 准备上麦， 点击后显示 举手 -->
                <div v-if="isPrepareSpeak" class="btn-wrap">
                    <div>
                        <div class="bjy-menu-speak-apply" @click="onPrepareSpeak">
                            <div class="bjy-menu-switcher">
                                <i class="icon icon-hand-up"></i>
                                <span data-title="准备上麦" class="bjy-label">准备上麦</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="isStudent && canSupportWebRTC" class="btn-wrap">
                    <SpeakApplyMenu />
                </div>

                <!-- 屏幕分享菜单 -->
                <!-- <div class="btn-wrap" v-if="canSupportWebRTC">
          <ShareScreenMenu />
        </div> -->
            </template>

            <!--      &lt;!&ndash; 弹幕按钮 &ndash;&gt;-->
            <!--      <div @click="toggleBarrage()" class="btn-wrap">-->
            <!--        <i v-if="isBarrageOn" class="icon icon-barrage-on"></i>-->
            <!--        <i v-else class="icon icon-barrage-off"></i>-->
            <!--        {{ barrageState }}-->
            <!--      </div>-->

            <!-- 线路切换 -->
            <div v-if="cdnList.length > 1 && liveInfo && liveInfo.webrtc !== 1" class="cdn-node-list btn-wrap">
                <div class="node-list-dialog" v-if="isShowNodeDialog">
                    <div
                        class="option"
                        :class="{ 'active-option': currentNode === index }"
                        v-for="index in cdnList.length"
                        :key="index"
                        :value="index"
                        @click="onTabNode(index)"
                    >
                        <span>{{ index | cdnListFilter }}</span>
                    </div>
                </div>
                <div>
                    <div class="bjy-menu-cdn-list" @click="isShowNodeDialog = !isShowNodeDialog">
                        <div class="bjy-menu-switcher">
                            <svg class="icon"><use xlink:href="#icon-switch-server"></use></svg>
                            <span data-title="线路" class="bjy-label">线路</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import language from '../../language/main'
import SpeakApplyMenu from './SpeakApplyMenu'
// import ShareScreenMenu from "./ShareScreenMenu";
import Record from './Record'

let store = BJY.store
let eventEmitter = BJY.eventEmitter
let auth = BJY.auth

export default {
    props: ['liveInfo'],
    components: {
        SpeakApplyMenu,
        // ShareScreenMenu,
        Record,
    },
    data() {
        return {
            canSupportWebRTC: auth.canSupportWebRTC(),
            language: language,
            isStudent: auth.isStudent(),
            barrage: null,
            isBarrageOn: false,
            cdnList: [],
            currentNode: 1,

            isPrepareSpeak: true,
            isShowNodeDialog: false,
        }
    },
    computed: {
        barrageState() {
            return this.isBarrageOn ? language.BARRAGE_ON : language.BARRAGE_OFF
        },
    },
    watch: {
        currentNode(newIndex, oldIndex) {
            console.log(newIndex)
            eventEmitter.trigger(eventEmitter.DOWNLINK_SERVER_NODE_CHANGE_TRIGGER, {
                index: newIndex - 1,
            })
        },
    },
    filters: {
        cdnListFilter(index) {
            return '线路' + index
        },
    },
    methods: {
        onPrepareSpeak() {
            if (BJY.browser.wechat) {
                this.$toast('微信内不支持上麦')
                return
            }
            this.isPrepareSpeak = false
            window.sessionStorage.setItem('prepareSpeakStatus', 1)
            window.location.reload()
        },
        onTabNode(index) {
            this.currentNode = index

            eventEmitter.trigger(eventEmitter.DOWNLINK_SERVER_NODE_CHANGE_TRIGGER, {
                index: index - 1,
            })
            setTimeout(() => {
                this.isShowNodeDialog = false
            }, 300)
        },

        toggleClassStart() {
            if (store.get('class.started')) {
                eventEmitter.trigger(eventEmitter.CLASS_END_TRIGGER)
            } else {
                eventEmitter.trigger(eventEmitter.CLASS_START_TRIGGER)
            }
        },
        toggleBarrage() {
            let isOpen = this.barrage.isOpened()
            if (isOpen) {
                this.barrage.close()
                this.isBarrageOn = false
            } else {
                this.barrage.open()
                this.isBarrageOn = true
            }
        },
        toggleQuiz() {
            eventEmitter.trigger('toggle_quiz_dialog')
        },
        toggleAnswer() {
            eventEmitter.trigger('toggle_answer_dialog')
        },
        toggleMediaPlayer() {
            eventEmitter.trigger('toggle_media_player')
        },
        toggleRollCall() {
            eventEmitter.trigger('toggle_roll_call')
        },
        toggleLottery() {
            eventEmitter.trigger('toggle_lottery')
        },
        toggleAttentionDetection() {
            eventEmitter.trigger('toggle_attention_detection')
        },
        toggleAnswerRacer() {
            eventEmitter.trigger('toggle_answer_racer')
        },
    },
    created() {
        this.isPrepareSpeak = window.sessionStorage.getItem('prepareSpeakStatus') != 1

        store.watch(
            'class.started',
            (started) => {
                if (started) {
                    // this.$toast(language.TIP_CLASS_START);
                } else {
                    // this.$toast(language.TIP_CLASS_END)
                }
                this.started = started
            },
            true
        )
        // 获取k可用的cdn节点
        this.cdnList = BJY.data.server.getLiveServerList()
    },
    mounted() {
        // 调用 create 方法创建弹幕组件
        // 弹幕组件不需要独立的容器，只需要在create中提供挂载的容器
        // this.barrage = new BJY.Barrage({
        //   // 组件父容器
        //   container: $(".class-panel"),
        //   // 移动速度，每秒移动多少个像素
        //   speed: 100,
        //   // 最长可显示多少个字，超过这个字数的会过滤
        //   maxLength: 20,
        //   // 在 top - bottom 的区间出现弹幕
        //   top: 30,
        //   bottom: 30,
        //   // 轨道高度
        //   trackHeight: 30,
        //   // 是否只显示文本消息
        //   textOnly: false,
        //   // 如果需要自定义弹幕内容，可实现此方法
        //   renderContent: function (data) {
        //     return data.content;
        //   },
        // });
    },
    beforeDestroy() {},
}
</script>

<style lang="scss">
//@import url(); 引入公共css类
.function-panel {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-grow: 1;

    .left,
    .right {
        display: flex;

        & > * {
            margin: 0 4px;
            padding: 2px 8px;
            cursor: pointer;
            display: flex;
            align-items: center;

            &:hover {
                border-radius: 4px;
                background-color: rgba(255, 255, 255, 0.3);
                color: #fff;
                transition: all 0.3s;
            }
        }

        .bjy-custom-record {
            display: flex;
            align-items: center;

            .bjy-menu-switcher {
                padding: 0;

                .bjy-label {
                    margin-left: 0;
                    vertical-align: unset;
                }

                &:hover {
                    background: none;
                    color: #bdc6cf;
                }
            }

            .bjy-cloud-record-ing:after {
                top: 5px;
                left: -7px;
            }
        }
        .cdn-node-list {
            position: relative;
            .node-list-dialog {
                position: absolute;
                bottom: 100%;
                left: 0;
                width: 100px;
                z-index: 10;
                background: rgba(255, 255, 255, 0.9);
                color: #333;
                -webkit-border-radius: 3px;
                -moz-border-radius: 3px;
                border-radius: 3px;
                -webkit-box-shadow: 0 4px 8px 0 rgba(36, 42, 54, 0.2);
                -moz-box-shadow: 0 4px 8px 0 rgba(36, 42, 54, 0.2);
                box-shadow: 0 4px 8px 0 rgba(36, 42, 54, 0.2);
                border: 1px solid rgba(159, 168, 181, 0.1);
                font-size: 12px;
                background: #313847;
                margin-bottom: 8px;
                padding: 0;
                overflow: hidden;
                .option {
                    align-items: center;
                    white-space: nowrap;
                    width: 100%;
                    position: relative;
                    height: 28px;
                    line-height: 28px;
                    text-align: left;
                    padding-left: 28px;
                    color: #9fa8b5;
                    &:hover {
                        background: rgba(255, 255, 255, 0.1);
                        color: #fff;
                        cursor: pointer;
                    }
                }
                .active-option {
                    &::before {
                        content: '';
                        position: absolute;
                        left: 12px;
                        top: 12px;
                        width: 6px;
                        height: 6px;
                        border-radius: 50%;
                        background-color: #00a1ff;
                    }
                }
            }
        }
        .bjy-menu-cdn-list {
            .icon {
                width: 28px;
                height: 28px;
                fill: rgba(255, 255, 255, 0.6);
                margin-right: 5px;
            }
            &:hover {
                .icon {
                    fill: #fff;
                }
            }
        }
    }

    .bjy-spacer {
        margin-right: 200px;
    }
}
</style>
